// extracted by mini-css-extract-plugin
module.exports = {"block":"ServicesBlock_block__1K-4m","list":"ServicesBlock_list__2v3Ro","additionalListItem":"ServicesBlock_additionalListItem__1Juty"};